import { TableCell, TableRow } from '@mui/material';
import React from 'react';

import EmptyContent from 'components/EmptyContent';
import useLocales from 'hooks/useLocales';

// ----------------------------------------------------------------------

type Props = {
    title?: string;
    isNotFound: boolean;
};

export default function TableNoData({ title, isNotFound }: Props) {
    const { translate } = useLocales();
    return (
        <TableRow>
            {isNotFound ? (
                <TableCell colSpan={31}>
                    <EmptyContent
                        title={title || translate('no_data')}
                        sx={{
                            '& span.MuiBox-root': { height: 160 },
                        }}
                    />
                </TableCell>
            ) : (
                <TableCell colSpan={31} sx={{ p: 0 }} />
            )}
        </TableRow>
    );
}
